import { isDemoPresentation } from '@/lib/constants'

import { Badge } from '@/components/ui/badge'

/**
 * Persistent "Demo Mode" honesty label (ADR 0006 dec. 8 · issue 04).
 *
 * Mounted once in the app header so every included route carries it. Self-gates
 * on `isDemoPresentation` — renders `null` in `dev:mock` and production, so it can never leak
 * outside the demo build regardless of where it is mounted. Distinct from the
 * marketing CTA (issue 05): this is a label, not a conversion affordance.
 *
 * `data-testid="demo-mode-indicator"` is the stable hook the Playwright smoke
 * (issue 06) asserts on.
 */
export function DemoModeIndicator() {
	if (!isDemoPresentation) return null

	return (
		<Badge variant="secondary" data-testid="demo-mode-indicator">
			Demo Mode
		</Badge>
	)
}
